
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CustomerStateData {
    id?: string
    name: string,
    contact: string,
    age: string,
    gender: string,
    locality: string,
    state: string,
    country: string,
    pincode: string,
    city: string,
    email?: string,
    membershipId?: string,
    gstin?: string,
}

const initialState: CustomerStateData[] = [];

const customerSlice = createSlice({
    name: "customers",
    initialState,
    reducers: {
        setCustomers(state, action: PayloadAction<CustomerStateData[]>) {
            return action.payload;
        },
        addCustomer(state, action: PayloadAction<CustomerStateData>) {
            state.unshift(action.payload)
        },
        resetCustomers() {
            return initialState;
        },
        deleteCustomer(state, action: PayloadAction<string>) {
            const index = state.findIndex((customer) => customer.id === action.payload);
            if (index === -1) {
                return state;
            }
            state.splice(index, 1);
            return state;
        }
    },
})

export const { setCustomers, addCustomer, resetCustomers, deleteCustomer } = customerSlice.actions;
export default customerSlice.reducer;